import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
    gap: 2,
    width: '100%',
    alignItems: 'stretch',
  },
  dayCard: {
    boxSizing: 'border-box',
    padding: 2,
    width: '100%',
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      gridColumn: 'span 1',
    },
    [theme.breakpoints.down('xs')]: {
      gridColumn: 'span 1',
    }
  },
  dayOuter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
  },
  parentCard: {
    width: '100%',
    minWidth: 0,
    borderRadius: 10,
    padding: 3,
    background: '#f5f7f8',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    boxSizing: 'border-box'
  },
  dayAbbrev: {
    fontSize: 9,
    color: '#486d86',
    fontWeight: 700,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  innerCard: {
    position: 'relative',
    width: '100%',
    minWidth: 0,
    minHeight: 38,
    background: '#fff',
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
    padding: '6px 4px',
    marginBottom: 4
  },
  dateText: {
    fontSize: 11.5,
    fontWeight: 800,
    color: '#002D55',
    textAlign: 'center'
  },
  badge: {
    position: 'absolute',
    top: 6,
    right: 6,
    minWidth: 22,
    height: 22,
    borderRadius: 11,
    background: '#fb741a',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 9,
    fontWeight: 700,
    transform: 'translate(10px, -15px)',
    boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
  }
}));

const WeeklyActivityCalendar = ({ weekData }) => {
  const classes = useStyles();

  // Ensure we have an array of 7 entries; if not, render what we have
  const days = Array.isArray(weekData) ? weekData : [];

  return (
    <Box className={classes.root}>
      {days.map((d, idx) => (
        <Box key={d && d.day ? d.day + idx : idx} className={classes.dayCard}>
          <Box className={classes.dayOuter}>
            <Paper className={classes.parentCard} elevation={0}>
              <Typography className={classes.dayAbbrev}>{d && d.day ? d.day : ''}</Typography>
              <Paper className={classes.innerCard} elevation={0}>
                <Typography className={classes.dateText}>{d && (typeof d.date === 'number' ? d.date : '')}</Typography>
                {d && d.sessions > 0 ? (
                  <Box className={classes.badge} aria-label={`${d.sessions} sessions`}>{d.sessions}</Box>
                ) : null}
              </Paper>
            </Paper>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

WeeklyActivityCalendar.propTypes = {
  weekData: PropTypes.arrayOf(PropTypes.shape({
    day: PropTypes.string.isRequired,
    date: PropTypes.number.isRequired,
    sessions: PropTypes.number.isRequired
  })).isRequired
};

WeeklyActivityCalendar.defaultProps = {
  weekData: [
    { day: 'Mon', date: 0, sessions: 0 },
    { day: 'Tue', date: 0, sessions: 0 },
    { day: 'Wed', date: 0, sessions: 0 },
    { day: 'Thu', date: 0, sessions: 0 },
    { day: 'Fri', date: 0, sessions: 0 },
    { day: 'Sat', date: 0, sessions: 0 },
    { day: 'Sun', date: 0, sessions: 0 }
  ]
};

export default WeeklyActivityCalendar;
